import { render, staticRenderFns } from "./Etablissements.vue?vue&type=template&id=50e4e1c4&scoped=true"
import script from "./Etablissements.vue?vue&type=script&lang=js"
export * from "./Etablissements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4e1c4",
  null
  
)

export default component.exports